module.exports = __webpack_public_path__ + "img/Medal@3x.0becd1fc.png";